import { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { MODAL_SIZES } from 'shared-modules/constants';
import {
  CONFIRM_MESSAGES,
  CONFIRM_MESSAGES_FOR_BUILD,
  CONFIRM_MESSAGES_FOR_TRENDFOLLOW,
} from 'shared-modules/constants/select';
import { Button, Modal } from '../../../../components';
import styles from './confirmModal.module.scss';

export const ConfirmModal = memo(({ isShare, isBuilder, isTrendFollow, visible, onClose, onClick }) => {
  const handleClick = useCallback(() => {
    onClick();
    onClose();
  }, [onClick, onClose]);

  let confirmMessage;
  if (isShare) {
    confirmMessage = CONFIRM_MESSAGES;
  } else if (isBuilder) {
    confirmMessage = CONFIRM_MESSAGES_FOR_BUILD;
  } else if (isTrendFollow) {
    confirmMessage = CONFIRM_MESSAGES_FOR_TRENDFOLLOW;
  } else {
    confirmMessage = CONFIRM_MESSAGES; // fallback
  }

  return (
    <Modal
      isOpen={visible}
      title="確認"
      closeModal={onClose}
      size={isShare ? MODAL_SIZES.WIDTH_512 : MODAL_SIZES.WIDTH_560}
      isOverlap
    >
      <div className={styles.content}>
        {confirmMessage.map((line, i) => (
          // eslint-disable-next-line react/no-array-index-key
          <div key={i} className={styles.message}>
            {line}
          </div>
        ))}
        <div className={styles.buttonArea}>
          <Button className={styles.button} onClick={onClose} secondary>
            キャンセル
          </Button>
          <Button className={styles.button} onClick={handleClick}>
            OK
          </Button>
        </div>
      </div>
    </Modal>
  );
});

ConfirmModal.propTypes = {
  isShare: PropTypes.bool.isRequired,
  isBuilder: PropTypes.bool.isRequired,
  isTrendFollow: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
};
